// Generated by CoffeeScript 1.12.7
(function () {
  var zeros;

  module.exports = function (num, n) {
    var frac, int, neg, ref;

    if (n === 0) {
      return num;
    }

    ref = ('' + num).split('.'), int = ref[0], frac = ref[1];
    int || (int = '0');
    frac || (frac = '0');
    neg = int[0] === '-' ? '-' : '';

    if (neg) {
      int = int.slice(1);
    }

    if (n > 0) {
      if (n > frac.length) {
        frac += zeros(n - frac.length);
      }

      int += frac.slice(0, n);
      frac = frac.slice(n);
    } else {
      n = n * -1;

      if (n > int.length) {
        int = zeros(n - int.length) + int;
      }

      frac = int.slice(n * -1) + frac;
      int = int.slice(0, n * -1);
    }

    while (int[0] === '0') {
      int = int.slice(1);
    }

    while (frac[frac.length - 1] === '0') {
      frac = frac.slice(0, -1);
    }

    return neg + (int || '0') + (frac.length ? '.' + frac : '');
  };

  zeros = function zeros(n) {
    return new Array(n + 1).join('0');
  };
}).call(this);